import type { Direction } from "../../../engine/direction";
import { BurstParticle } from "./burstParticle";

export class PlasticDebrisParticle extends BurstParticle {
	constructor(originX: number, originY: number, direction?: Direction) {
		super(
			originX,
			originY,
			{
				ttl: [250, 450],
				size: [0.35, 0.2],
				color: { r: 233, g: 238, b: 255 },
				speed: [1.5, 3.0],
				gravity: 4.0,
			},
			direction,
		);
	}
}
